<template lang="pug">
  div
    v-simple-table
      template(v-slot:default)
        thead
          tr
            th {{ translations.label.no }}
            th {{ translations.label.description }}
            th {{ translations.label.qty }}
            th {{ translations.label.price }}
            th {{ translations.label.discount }}
            th {{ translations.label.tax }}
            th {{ translations.label.total }}
            th
        tbody
          tr(v-for="(field,j) in createdFields" :key="'field'+j")
            td.py-2 {{ j+1 }}
            td.py-2 {{ field.description }}
            td.py-2 {{ field.qty }}
            td.py-2 {{ field.price }}
            td.py-2 {{ field.discount }}
            td.py-2 {{ field.tax }}
            td.py-2 {{ currencyFormat(field.total, '€') }}
            td.py-2
              v-btn(@click="removeField(field.id)" color="red lighten-2" dark small) {{ translations.button.remove }}
          tr
            td.py-2
            td.py-2
              v-text-field(v-model="emptyfield.description" dense hide-details single-line)
                template(v-slot:label)
                  v-icon.pr-1(color="red accent-2" size="8") mdi-asterisk
                  | {{ translations.label.description }}
            td.py-2
              v-text-field(v-model="emptyfield.qty" dense hide-details single-line)
                template(v-slot:label)
                  v-icon.pr-1(color="red accent-2" size="8") mdi-asterisk
                  | {{ translations.label.qty }}
            td.py-2
              v-text-field(v-model="emptyfield.price" dense hide-details single-line)
                template(v-slot:label)
                  v-icon.pr-1(color="red accent-2" size="8") mdi-asterisk
                  | {{ translations.label.price }}
            td.py-2
              v-text-field(v-model="emptyfield.discount", :label="translations.label.discount" dense hide-details single-line)
            td.py-2
              v-text-field(v-model="emptyfield.tax", :label="translations.label.tax" dense hide-details single-line)
            td.py-2
            td.py-2
              v-btn(@click="addField" color="green lighten-1" dark small) {{ translations.button.add }}
    v-dialog.grey(v-model="dialog" max-width="400")
      v-card
        v-card-title.d-flex.flex-nowrap.justify-space-between.headline.text-center(primary-title)
          span {{ translations.dialog.title }}
          v-btn(@click="dialog = false" icon)
            v-icon mdi-close
        v-card-text
          v-row.text-center
            v-col(cols="12")
              p {{ translations.dialog.text }}
            v-col(cols="12")
              v-btn(@click="dialog = false") {{ translations.dialog.button }}
</template>

<script>
  export default {
    name: "BaseInvoiceItemsField",
    model: {
      prop: 'value',
      event: 'input'
    },
    props: {
      value: {
        type: Array,
        default: function(){
          return []
        }
      },
    },
    data:() => ({
      emptyfield: {
        id: '',
        description: '',
        qty: '',
        price: '',
        discount: '',
        tax: '',
        total: '',
        discount_amount: '',
        tax_amount: '',
      },
      indexkey: 0,
      createdFields: [],
      sendFields: [],
      dialog: false,
    }),
    computed: {
      translations(){
        return this.$t("components.baseInvoiceItemsField");
      }
    },
    watch: {
      value: function(val){
        this.createdFields = val;
      }
    },
    created(){
      this.createdFields = this.value;
    },
    methods:{
      addField(){
        // const that = this
        if (isNaN(parseFloat(this.emptyfield.qty)) || isNaN(parseFloat(this.emptyfield.price)) || this.emptyfield.description == ''){
          this.dialog = true;
        } else {
          this.indexkey++;
          const item = {
            qty: parseFloat(this.emptyfield.qty),
            price: parseFloat(this.emptyfield.price),
            discount: isNaN(parseFloat(this.emptyfield.discount)) ? 0 : parseFloat(this.emptyfield.discount),
            tax: isNaN(parseFloat(this.emptyfield.tax)) ? 0 : parseFloat(this.emptyfield.tax),
            discount_amount: 0,
            tax_amount: 0,
            total: 0,
          };
          let total_default = item.qty * item.price;
          if(item.discount > 0){
            item.discount_amount = parseFloat((total_default * (item.discount / 100)).toFixed(2));
          }
          if(!isNaN(item.tax) && item.tax > 0){
            item.tax_amount = parseFloat(((total_default - item.discount_amount) * (item.tax / 100)).toFixed(2));
          }
          item.total = parseFloat((total_default - item.discount_amount + item.tax_amount).toFixed(2));

          this.createdFields.push({
            id: this.indexkey,
            description: this.emptyfield.description,
            qty: this.emptyfield.qty,
            price: this.emptyfield.price,
            discount: item.discount,
            tax: item.tax,
            discount_amount: item.discount_amount,
            tax_amount: item.tax_amount,
            total: item.total,
          });

          this.sendFields.push({
            description: this.emptyfield.description,
            qty: item.qty,
            price: item.price,
            discount: item.discount,
            tax: item.tax,
            discount_amount: item.discount_amount,
            tax_amount: item.tax_amount,
            total: item.total,
          });
          this.emptyfield = { description: '', qty: '', price: '', discount: '', tax: '', total: '', discount_amount: '', tax_amount: '' };
          this.$emit('input', this.sendFields);
        }
      },
      removeField(id){
        for( let i = 0; i < this.createdFields.length; i++){
          if ( this.createdFields[i].id === id) { 
            this.createdFields.splice(i, 1);
            this.sendFields = this.createdFields.map((item)=>{return{
              description: item.description,
              qty: parseFloat(item.qty),
              price: parseFloat(item.price),
              discount: parseFloat(item.discount),
              tax: parseFloat(item.tax),
              discount_amount: item.discount_amount,
              tax_amount: item.tax_amount,
              total: item.total,
            }});
            this.$emit('input', this.sendFields);
          }
        }
      },
      clear(){
        this.emptyfield.description = '';
        this.emptyfield.qty = '';
        this.emptyfield.price = '';
        this.emptyfield.discount = '';
        this.emptyfield.tax = '';
        this.emptyfield.total = '';
        this.emptyfield.discount_amount = '';
        this.emptyfield.tax_amount = '';
      },
    },
  }
</script>

<style lang="sass">
</style>